<div [ngClass]="data ? 'modalSafeStyle modal-sticky-loader' : ''">

  <mat-progress-bar mode="indeterminate" *ngIf="showSpinner"></mat-progress-bar>

  <div [ngClass]="showSpinner ? 'loading' : ''">

    <div class="modal-header">
      <div class="titleCont">
        <h3 class="modal-title">{{'SELECT' | translate}}</h3>
      </div>
      <br/>
      <button type="button" class="close" aria-label="Close" matDialogClose>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>


    <div class="mainCont">

      <div ngfDrop
           multiple="1"
           selectable="1"
           [(files)]="files"
           (filesChange)="addFiles($event)"
           class="well dropZone">
        <div class="dropZoneDotted bootstrapStyle">
          <div id="dragMessage">
            {{'PLANS_FORM_DRAG_HERE' | translate}}
          </div>
          <div id="dragOrMessage">
            {{'PLANS_FORM_OR' | translate}}
          </div>
          <button class="btn btn-primary">
            {{'PLANS_FORM_CLICK_HERE' | translate}}
          </button>
          <div class="textWarning">
            Type de fichier : jpg <br>
            Taille de fichier maximal : 20Mo
          </div>
        </div>
      </div>

      <div class="thumbnailCont">
        <div *ngFor="let item of files;let i=index"
             class="thumbnail">
          <div *ngIf="item.encodedImage">
            <img [src]="item.encodedImage">
          </div>
          <div class="thumbnailName">{{ item.name }}</div>
          <div class="cancelButton" (click)="files.splice(i,1)">
            <fa-icon [icon]="iconService.faTimes"></fa-icon>
          </div>
        </div>
      </div>

    </div>

    <hr>

    <div class="bootstrapStyle submitCont">
      <button class="btn btn-primary"
              (click)="submitFiles()"
              [disabled]="!files">
        {{'DOWNLOAD' | translate}}
      </button>
      <button class="btn btn-cancel">{{'CANCEL' | translate}}</button>
    </div>

  </div>

</div>
